export const articles = [
  {
    slug: "what-is-darknet",
    title: "什么是暗网？全面了解暗网的定义与层级结构",
    excerpt: "暗网并非一个神秘的黑客世界，而是互联网架构中一个特定的层级。本文从技术角度出发，全面解析暗网的定义、发展历史及工作原理。",
    category: "darknet-basics",
    image: "https://readdy.ai/api/search-image?query=Abstract%20digital%20network%20visualization%20with%20layered%20onion%20structure%2C%20dark%20background%20with%20glowing%20amber%20and%20teal%20nodes%2C%20cybersecurity%20concept%20art%2C%20minimal%20clean%20design%2C%20data%20flow%20diagram%20style%2C%20no%20text&width=800&height=500&seq=article-darknet-def-01&orientation=landscape",
    date: "2026-07-28",
    readTime: "8分钟",
    tags: ["暗网", "深网", "互联网架构", "基础知识"],
  },
  {
    slug: "darknet-vs-deepweb",
    title: "暗网 vs 深网：别再混淆这两个概念",
    excerpt: "很多人将暗网与深网混为一谈，实际上它们是两个完全不同的概念。本文清晰梳理两者的定义、范围与区别，帮你建立准确的认知。",
    category: "darknet-basics",
    image: "https://readdy.ai/api/search-image?query=Comparison%20diagram%20style%2C%20two%20overlapping%20circles%20showing%20surface%20web%20vs%20deep%20web%20vs%20dark%20web%2C%20clean%20infographic%20aesthetic%2C%20amber%20and%20teal%20accents%20on%20dark%20background%2C%20minimal%20design&width=800&height=500&seq=article-darknet-vs-01&orientation=landscape",
    date: "2026-07-25",
    readTime: "6分钟",
    tags: ["暗网", "深网", "概念辨析", "基础知识"],
  },
  {
    slug: "tor-network-explained",
    title: "Tor网络技术详解：洋葱路由的工作原理",
    excerpt: "Tor（The Onion Router）是访问暗网最常用的工具。本文深入浅出地讲解洋葱路由的加密原理、节点机制和匿名性保障。",
    category: "operation-mechanism",
    image: "https://readdy.ai/api/search-image?query=Abstract%20onion%20layers%20visualization%2C%20concentric%20circles%20representing%20encryption%20layers%2C%20network%20nodes%20connected%20by%20glowing%20lines%2C%20dark%20background%20with%20amber%20highlights%2C%20minimal%20tech%20illustration&width=800&height=500&seq=article-tor-01&orientation=landscape",
    date: "2026-07-22",
    readTime: "10分钟",
    tags: ["Tor", "洋葱路由", "加密技术", "匿名网络"],
  },
  {
    slug: "crypto-darknet-economy",
    title: "加密货币与暗网经济：匿名交易的背后",
    excerpt: "比特币、门罗币等加密货币为何成为暗网交易的宠儿？本文分析暗网经济中的支付体系与资金流向，揭示匿名交易的运作逻辑。",
    category: "operation-mechanism",
    image: "https://readdy.ai/api/search-image?query=Abstract%20cryptocurrency%20concept%2C%20digital%20coins%20floating%20in%20dark%20space%2C%20blockchain%20network%20visualization%2C%20amber%20and%20teal%20glowing%20connections%2C%20minimal%20futuristic%20style%2C%20no%20text&width=800&height=500&seq=article-crypto-01&orientation=landscape",
    date: "2026-07-20",
    readTime: "9分钟",
    tags: ["加密货币", "比特币", "门罗币", "暗网经济"],
  },
  {
    slug: "darknet-scams-exposed",
    title: "暗网常见诈骗手法揭秘：保护自己远离陷阱",
    excerpt: "暗网充斥着各类诈骗行为：虚假市场、钓鱼攻击、勒索软件……本文盘点暗网最常见的诈骗手法，教你如何识别和防范。",
    category: "risk-identification",
    image: "https://readdy.ai/api/search-image?query=Abstract%20warning%20concept%2C%20silhouette%20figure%20surrounded%20by%20digital%20traps%20and%20hooks%2C%20dark%20atmosphere%20with%20amber%20warning%20glow%2C%20cybersecurity%20threat%20visualization%2C%20minimal%20design&width=800&height=500&seq=article-scams-01&orientation=landscape",
    date: "2026-07-18",
    readTime: "7分钟",
    tags: ["诈骗", "暗网风险", "钓鱼攻击", "安全警示"],
  },
  {
    slug: "malware-darknet-threats",
    title: "暗网中的恶意软件威胁：勒索病毒与木马分析",
    excerpt: "暗网是恶意软件交易和传播的温床。本文深入分析暗网中常见的恶意软件类型、传播途径以及防御策略。",
    category: "risk-identification",
    image: "https://readdy.ai/api/search-image?query=Abstract%20virus%20and%20malware%20concept%2C%20digital%20code%20corrupted%20by%20red%20and%20amber%20glitches%2C%20dark%20background%2C%20tech%20security%20threat%20visualization%2C%20minimal%20style%2C%20no%20text&width=800&height=500&seq=article-malware-01&orientation=landscape",
    date: "2026-07-15",
    readTime: "8分钟",
    tags: ["恶意软件", "勒索病毒", "木马", "安全威胁"],
  },
  {
    slug: "password-security-guide",
    title: "密码安全完全指南：创建和管理强密码的最佳实践",
    excerpt: "弱密码是个人信息泄露的最大隐患之一。本文提供实用的密码创建、管理和保护策略，帮助你大幅提升账户安全性。",
    category: "personal-protection",
    image: "https://readdy.ai/api/search-image?query=Abstract%20password%20security%20concept%2C%20shield%20made%20of%20encrypted%20characters%2C%20clean%20minimal%20design%2C%20teal%20and%20amber%20accents%20on%20dark%20background%2C%20digital%20protection%20symbol&width=800&height=500&seq=article-password-01&orientation=landscape",
    date: "2026-07-12",
    readTime: "6分钟",
    tags: ["密码安全", "账户保护", "最佳实践", "个人防护"],
  },
  {
    slug: "two-factor-auth-setup",
    title: "双因素认证设置教程：为你的账号加上第二把锁",
    excerpt: "双因素认证（2FA）是保护在线账户的最有效手段之一。本文手把手教你为各类常用平台设置双因素认证。",
    category: "personal-protection",
    image: "https://readdy.ai/api/search-image?query=Abstract%20two%20factor%20authentication%20concept%2C%20phone%20and%20lock%20icon%20combined%2C%20clean%20minimal%20design%2C%20teal%20and%20amber%20accents%20on%20dark%20background%2C%20security%20verification%20visual&width=800&height=500&seq=article-2fa-01&orientation=landscape",
    date: "2026-07-10",
    readTime: "5分钟",
    tags: ["双因素认证", "2FA", "账户安全", "教程"],
  },
  {
    slug: "china-cybersecurity-law",
    title: "中国网络安全法解读：每个网民都应该知道的法律条款",
    excerpt: "《中华人民共和国网络安全法》是网络空间治理的基础性法律。本文梳理核心条款，帮助普通网民了解法律赋予的权利和义务。",
    category: "legal-compliance",
    image: "https://readdy.ai/api/search-image?query=Abstract%20legal%20concept%2C%20scales%20of%20justice%20integrated%20with%20digital%20network%2C%20clean%20authoritative%20design%2C%20amber%20and%20teal%20accents%20on%20dark%20background%2C%20minimal%20style&width=800&height=500&seq=article-law-01&orientation=landscape",
    date: "2026-07-08",
    readTime: "7分钟",
    tags: ["网络安全法", "法律法规", "权利与义务", "合规"],
  },
  {
    slug: "personal-info-protection-law",
    title: "个人信息保护法详解：你的数据谁说了算？",
    excerpt: "《个人信息保护法》于2021年正式施行，为个人信息权益提供了法律保障。本文详细解读该法的核心内容和实际应用。",
    category: "legal-compliance",
    image: "https://readdy.ai/api/search-image?query=Abstract%20personal%20data%20protection%20concept%2C%20lock%20surrounded%20by%20data%20streams%2C%20clean%20authoritative%20design%2C%20amber%20and%20teal%20accents%20on%20dark%20background%2C%20minimal%20tech%20legal%20illustration&width=800&height=500&seq=article-pipl-01&orientation=landscape",
    date: "2026-07-05",
    readTime: "8分钟",
    tags: ["个人信息保护法", "数据安全", "隐私权", "法律法规"],
  },
  {
    slug: "silk-road-case-study",
    title: "丝路网站案：暗网史上最大犯罪平台的覆灭",
    excerpt: "Silk Road（丝路）是暗网历史上最臭名昭著的非法交易平台。本文回顾其兴衰历程，分析其运作模式和最终被取缔的过程。",
    category: "case-analysis",
    image: "https://readdy.ai/api/search-image?query=Abstract%20dark%20web%20marketplace%20concept%2C%20digital%20scales%20and%20handcuffs%20in%20cyber%20space%2C%20dark%20atmosphere%20with%20amber%20caution%20glow%2C%20investigation%20theme%2C%20minimal%20style&width=800&height=500&seq=article-silkroad-01&orientation=landscape",
    date: "2026-07-02",
    readTime: "12分钟",
    tags: ["丝路网站", "案例分析", "暗网市场", "执法行动"],
  },
  {
    slug: "data-breach-real-cases",
    title: "近年重大数据泄露事件盘点：从案例中学习防护",
    excerpt: "数据泄露事件频发，数以亿计的用户信息被曝光。本文盘点近年重大数据泄露事件，总结教训并提供实用防护建议。",
    category: "case-analysis",
    image: "https://readdy.ai/api/search-image?query=Abstract%20data%20breach%20concept%2C%20cracked%20digital%20shield%20leaking%20data%20streams%2C%20dark%20background%20with%20amber%20warning%20highlights%2C%20cybersecurity%20incident%20visualization%2C%20minimal%20design&width=800&height=500&seq=article-breach-01&orientation=landscape",
    date: "2026-06-28",
    readTime: "10分钟",
    tags: ["数据泄露", "案例分析", "信息安全", "防护建议"],
  },
];

export const getArticleBySlug = (slug: string) =>
  articles.find((a) => a.slug === slug);

export const getArticlesByCategory = (categorySlug: string) =>
  articles.filter((a) => a.category === categorySlug);

export const getRelatedArticles = (currentSlug: string, category: string, count = 3) =>
  articles
    .filter((a) => a.category === category && a.slug !== currentSlug)
    .slice(0, count);